import * as React from 'react';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';

import { HeaderField, HeaderStickyField } from '../../../../../../components/Field/common/HeaderField';
import { Content, FullscreenPopup, Header } from '../../../../../../components/FullscreenPopup';
import { CallButtonContainer } from '../../../../../CallButton';
import { FullscreenGalleryTabsContainer } from '../../../../../FullscreenGalleryTabs';
import { FavoriteContainer } from '../../../../../Favorite';
import { useOfferContext } from '../../../../../../utils/offerContext';
import { useHeaderControls } from '../../utils/hooks/useHeaderControls';

export interface IFlatSaleHeaderFieldContainerProps {
  dragging?: boolean;
  sticky?: boolean;
}

export const FlatSaleHeaderFieldContainer: React.VFC<IFlatSaleHeaderFieldContainerProps> = ({ dragging, sticky }) => {
  const { id, title, price, published, gallery } = useOfferContext();
  const { galleryOpened, onGalleryClose, ...fieldProps } = useHeaderControls();

  return (
    <>
      {sticky ? (
        <HeaderStickyField
          price={price.total}
          phone={<CallButtonContainer placeType="compareItemStickyHeader" action="Open_compare_listing" />}
          dragging={dragging}
          {...fieldProps}
        />
      ) : (
        <HeaderField dragging={dragging} {...fieldProps} />
      )}
      <FullscreenPopup
        isOpened={galleryOpened}
        header={
          <Header
            tabs={
              gallery && gallery.length > 1 ? <FullscreenGalleryTabsContainer gallery={gallery} offerId={id} /> : title
            }
            onClose={onGalleryClose}
            favorite={<FavoriteContainer />}
            call={
              <CallButtonContainer
                placeType="compareFullscreenGalleryStickyHeader"
                buttonIcon={<IconCommunicationPhone16 color="white_100" />}
                action="Open_compare_flatplan"
              />
            }
          />
        }
        onClose={onGalleryClose}
        content={gallery ? <Content published={published} gallery={gallery} /> : null}
      />
    </>
  );
};
